if (!window.teplepCardHoverVideoInitialized) {
  window.teplepCardHoverVideoInitialized = true;

  const hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('pointerover', (event) => {
    if (!hoverDevice.matches || reducedMotion.matches) return;

    const card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;

    const video = card.querySelector('.card__hover-video');
    if (video) video.play().catch(() => {});
  });

  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;

    const video = card.querySelector('.card__hover-video');
    if (!video) return;

    video.pause();
    if (video.readyState > 0) video.currentTime = 0;
  });
}
